//
//
//
//
//
//
//
//
//
//
//
//
import { sendSock, initWebSocket, websocketclose } from '@/util/socket.js';
export default {
  data: function data() {
    return {};
  },
  mounted: function mounted() {// this.getsocket()
  },
  methods: {
    getsocket: function getsocket() {
      initWebSocket("ws://121.40.169.186:5001/ws?type=4$topic=", 0);
      sendSock('', 0, function (res) {
        console.log(res);
      });
    }
  }
};